import { Component, OnInit, Inject, Optional } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  ALLOW,
  ALLOW_USE_LOCATION,
  ALLOW_USE_LOCATION_DESC,
  CLOSE,
  DONT_ALLOW,
  LOCATION_PERMISSION_DENIED,
  OK_BUTTON,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { UserLocationService } from 'src/app/@shared/services/user-location/user-location.service';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';

@Component({
    selector: 'app-location-use-pop-up',
    templateUrl: './location-use-pop-up.component.html',
    styleUrls: ['./location-use-pop-up.component.scss'],
    standalone: false
})
export class LocationUsePopUpComponent
  extends PopUpComponent
  implements OnInit
{
  direction: Direction;
  allowText: string;
  dontAllowText: string;
  okButtonText: string;
  allowUseLocationText: string;
  allowUseLocationDescText: string;
  locationPermissionDeniedText: string;
  /**
   * a11y: localized aria-label for the new top close (X) button. The popup
   * previously had no dedicated close affordance — only Allow / Don't allow
   * actions. The audit requires every popup to expose a close button at the
   * top that also receives initial focus on open.
   */
  closeText: string;

  // Flag to determine if we're showing the permission denied message
  isPermissionDenied: boolean = false;

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    private readonly languageService: LanguageService,
    @Optional() @Inject(POPUP_DATA) public data: any
  ) {
    super(routePlanningService, resizeService, overlay);
    this.isPermissionDenied = data?.permissionDenied || false;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.allowText = ALLOW[language.language];
      this.dontAllowText = DONT_ALLOW[language.language];
      this.okButtonText = OK_BUTTON[language.language];
      this.allowUseLocationText = ALLOW_USE_LOCATION[language.language];
      this.allowUseLocationDescText =
        ALLOW_USE_LOCATION_DESC[language.language];
      this.locationPermissionDeniedText =
        LOCATION_PERMISSION_DENIED[language.language];
      this.closeText = CLOSE[language.language];
    });
  }

  handleClick(allowLocationUsing: boolean) {
    this.closeCard(allowLocationUsing);
  }
}
